import { TaskBoardModel } from "../TaskBoard";
import { transformTaskCustomFieldDtoToTaskCustomFieldModel } from "../TaskCustomField";
import { PreviewTaskBoardDto } from "./PreviewTaskBoardDto";
import { PreviewTaskBoardModel } from "./PreviewTaskBoardModel";

// PreviewTaskBoardDto -> PreviewTaskBoardModel
export const transformPreviewTaskBoardDtoToModel = (
  boardId: string,
  dto: PreviewTaskBoardDto
): PreviewTaskBoardModel => ({
  id: boardId,
  name: dto.name,
  color: dto.color,
  customStatuses: dto.custom_statuses,
  customFields: dto.custom_fields.map(
    transformTaskCustomFieldDtoToTaskCustomFieldModel
  ),
  prefix: dto.prefix || "",
  fieldsSettings: dto.settings.fields || {},
  taskObjectNaming: {
    singular: dto.settings.item_name_singular || "",
    plural: dto.settings.item_name_plural || "",
  },
  includeOrderDetails: dto.settings.include_order_details || false,
  includeBillingFiles: dto.settings.include_invoice_docs || false,
});

// PreviewTaskBoardModel -> TaskBoardModel
export const transformPreviewTaskBoardModelToTaskBoardModel = (
  previewTaskBoardModel: PreviewTaskBoardModel
): TaskBoardModel => ({
  description: "",
  users: [],
  // NOTE: it is very important to spread the model properties at the end!
  // Due to strange RTKQ behavior when upserting cache data,
  // sometimes the complete `TaskBoardModel` will be provided instead of the preview (partial) one.
  // In that case, we don't want to override its actual values.
  ...previewTaskBoardModel,
});
